/*
 * @Description: 产品及产品管理有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  产品: '产品',
  新增产品: '新增产品',
  价格信息: '价格信息',
  编辑产品: '编辑产品',
  新增价格: '新增价格',
  编辑价格: '编辑价格',
  认缴信息: '认缴信息',
  实缴信息: '实缴信息'
};
